export default __webpack_public_path__ + "static/media/finger_right.f403b9d0.svg";